import { render, staticRenderFns } from "./PlcRecords.vue?vue&type=template&id=25f03105&scoped=true"
import script from "./PlcRecords.vue?vue&type=script&lang=js"
export * from "./PlcRecords.vue?vue&type=script&lang=js"
import style0 from "./PlcRecords.vue?vue&type=style&index=0&id=25f03105&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f03105",
  null
  
)

export default component.exports